module['exports'] = [
  'چھوٹے',
  'بڑے',
  'پہل',
  'دوم',
  'سوم',
  'چہارم',
  'پنجم',
  'ششم',
  'هفتم',
  'نوئم',
  'دسم',
];
